import React from 'react';
import PropTypes from 'prop-types';
import { IconSVG } from 'components';
import './SliderArrow.scss';

const SliderArrow = ({
  className,
  onClick,
  left,
  id,
  defaultClasses,
  color,
  ...other
}) => {
  const sideClass = left ? 'slide-prev' : 'slide-next';
  return (
    <div
      className={`slide-arrow ${sideClass} ${defaultClasses ? className : ''}`}
      onClick={onClick}
      role={'presentation'}
      id={id}
    >
      <IconSVG name={left ? 'arrow-left' : 'arrow-right'} color={color} />
    </div>
  );
};

SliderArrow.defaultProps = {
  left: false,
  color: 'black',
  defaultClasses: false,
};

SliderArrow.propTypes = {
  left: PropTypes.bool,
  color: PropTypes.string,
  defaultClasses: PropTypes.bool,
};

export default SliderArrow;
